import Vue from 'vue'

export const state = Vue.observable({
  discoveryScrollHeight: {},
  routesStack: []
})

export const isStackEmpty = () => {
  return state.routesStack.length === 0
}

export const pushStack = (item) => {
  state.routesStack.push(item)
  console.log('stackList: ' + state.routesStack.length)
  console.log('stackList: ' + state.routesStack)
}

export const popStack = (item) => {
  if (!isStackEmpty()) {
    state.routesStack.pop()
  }
  console.log('stackList: ' + state.routesStack.length)
  console.log('stackList: ' + state.routesStack)
}

export const geeStackTopScrollHeight = () => {
  if (isStackEmpty()) {
    return 0
  }
  return state.routesStack[state.routesStack.length - 1].scrollHeight
}

export const updateStackTopScrollHeight = (scrollHeight) => {
  const item = getStackTop()
  item.scrollHeight = scrollHeight
}

export const getStackTop = () => {
  if (isStackEmpty()) {
    throw new Error('Empty stack!')
  }
  return state.routesStack[state.routesStack.length - 1]
}
